// Cookie utility functions

/**
 * Get the appropriate domain for cookie setting based on current environment
 */
const getCookieDomain = (): string => {
  const hostname = window.location.hostname;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    // For development environment
    return "; domain=localhost";
  } else if (hostname.includes("analyticalplatform.com")) {
    // For test and production environments (both use .analyticalplatform.com)
    return "; domain=.analyticalplatform.com";
  } else {
    // Fallback: no domain (defaults to current host)
    return "";
  }
};

export const setCookie = (name: string, value: string, days?: number): void => {
  let expires = "";

  const date = new Date();
  date.setTime(date.getTime() + (days ? days : 1) * 24 * 60 * 60 * 1000);
  expires = "; expires=" + date.toUTCString();

  const domain = getCookieDomain();
  document.cookie = name + "=" + value + expires + "; path=/" + domain;
};

export const getCookie = (name: string): string | null => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const deleteCookie = (name: string): void => {
  const domain = getCookieDomain();

  // Delete cookie with the appropriate domain
  document.cookie = name + "=; Max-Age=-99999999; path=/" + domain;

  // Also try to delete without domain as fallback
  document.cookie = name + "=; Max-Age=-99999999; path=/";
};
